import { api } from "@risalabs_frontend_org/api-client";
import { API_ENDPOINTS } from "../../../enums/apiUrls";
import type {
  ClearHistoricNarLaneRequest,
  ClearHistoricNarLaneResponse,
  HistoricNarRecommendation,
  IngestHistoricNarRequest,
  IngestHistoricNarResponse,
  ListAllHistoricNarFilters,
  ListHistoricNarRequest,
  ListHistoricNarResponse,
} from "./types";

const HISTORIC_NAR_PAGE_SIZE = 500;

/** Authenticated API access for Historic NAR recommendations. */
export class HistoricNarService {
  /** Fetch one backend page of recommendations. */
  static async listRecommendations(
    request: ListHistoricNarRequest = {},
    signal?: AbortSignal,
  ): Promise<ListHistoricNarResponse> {
    return api.post<ListHistoricNarRequest, ListHistoricNarResponse>(
      API_ENDPOINTS.LIST_HISTORIC_NAR,
      request,
      signal,
    );
  }

  /** Fetch all recommendation pages using the backend's reported total. */
  static async listAllRecommendations(
    filters: ListAllHistoricNarFilters = {},
    signal?: AbortSignal,
  ): Promise<HistoricNarRecommendation[]> {
    const recommendations: HistoricNarRecommendation[] = [];
    let offset = 0;
    let total = Infinity;

    while (offset < total) {
      const response = await this.listRecommendations(
        {
          ...filters,
          limit: HISTORIC_NAR_PAGE_SIZE,
          offset,
        },
        signal,
      );
      recommendations.push(...response.items);
      total = response.total;
      offset += HISTORIC_NAR_PAGE_SIZE;

      if (response.items.length < HISTORIC_NAR_PAGE_SIZE) break;
    }

    return recommendations;
  }

  /** Create or link an Auth Grid row from a Historic NAR recommendation. */
  static async ingestRecommendation(
    request: IngestHistoricNarRequest,
    signal?: AbortSignal,
  ): Promise<IngestHistoricNarResponse> {
    return api.post<IngestHistoricNarRequest, IngestHistoricNarResponse>(
      API_ENDPOINTS.INGEST_HISTORIC_NAR,
      request,
      signal,
    );
  }

  /** Clear a recommendation from the Needs Review lane. */
  static async clearNarLane(
    request: ClearHistoricNarLaneRequest,
    signal?: AbortSignal,
  ): Promise<ClearHistoricNarLaneResponse> {
    return api.post<ClearHistoricNarLaneRequest, ClearHistoricNarLaneResponse>(
      API_ENDPOINTS.CLEAR_HISTORIC_NAR_LANE,
      request,
      signal,
    );
  }
}
